import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { Icon } from "@iconify/react";
import { Drawer, Modal } from "antd";
import UploadwithAI from "../../modals/uploadwithAI";
import LogoutModal from "../../modals/LogoutModal";
import { generateRandomId } from "../../utils/helpers";
import FeedbackModal from "../../modals/feedbackModal";
import { useTranslation } from "react-i18next";

const Sidebar = ({ isDrawerOpen, toggleDrawer }) => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isreminderModalOpen, setisreminderModalOpen] = useState(false);
  const [isuploadModelOpen, setisuploadModelOpen] = useState(false);
  const location = useLocation();
  const [isdropdownopen, setIsdropdownopen] = useState(false);
  const { t } = useTranslation();

  const onDropdownClick = () => {
    setIsdropdownopen(!isdropdownopen);
  };
  const onlogoutClick = () => {
    setIsModalOpen(true);
  };
  const onRateUSClick = () => {
    setisreminderModalOpen(true);
  };
  const onuploadwithAIClick = () => {
    setisuploadModelOpen(true);
  };

  const randomId = generateRandomId();

  return (
    <>
      <div className="sidebar-main-container py-[18px] pl-[18px] max-md:hidden max-w-[270px] w-full fixed flex flex-col overflow-y-auto h-screen ">
        <div className="sidebar-logo-container relative h-[147px]">
          <img
            src="../../assets/images/dashboard/dash-side.png"
            alt=""
            className="filter drop-shadow-md relative"
          />
          <div className="flex items-center gap-[13px] absolute top-[18%] left-[50%] transform -translate-x-[50%] min-w-[196px]">
            <Link to="/" target="_blank">
              <img
                src="../../logo.png"
                alt="logo"
                className="logo w-[39px] h-[33px]"
              />
            </Link>
            <h6 className="text-blue font-medium">
              {t("dashboard.sidebar.logo")}
            </h6>
          </div>
        </div>

        <div className="sidebar-options-container drop-shadow-md bg-[#F8F8F8] min-h-fit h-full mt-[10px] relative  rounded-b-[20px] rounded-t-[140px]">
          <img
            src="../../assets/images/dashboard/dash-side-bottom.png"
            alt=""
            className="filter  absolute  mt-[-41px]  h-full w-full object-fill"
          />
          <ul className="flex flex-col justify-between relative mt-[30px]  min-h-[calc(100%-43px)] p-[7px] w-full max-w-[264px]">
            <div className="top-options flex flex-col gap-[15px]">
              <li>
                <NavLink
                  to="/dashboard"
                  className={({ isActive }) =>
                    `dashLinks w-full max-w-[254px] rounded-[31px] flex items-center gap-[10px] px-[20px] py-[10px]  ${
                      isActive ? "bg-darkblue text-white" : "text-[#143A62]"
                    }`
                  }
                >
                  <Icon icon="ph:house-simple" width={18} height={18} />
                  <p className="medium font-medium">
                    {t("dashboard.sidebar.home")}
                  </p>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={`/chatbot`}
                  className={({ isActive }) =>
                    `dashLinks w-full max-w-[254px] rounded-[31px] flex items-center gap-[10px] px-[20px] py-[10px]  ${
                      isActive ? "bg-darkblue text-white" : "text-[#143A62]"
                    }`
                  }
                >
                  <Icon icon="carbon:chat-bot" width={18} height={18} />
                  <p className="medium font-medium">
                    {t("dashboard.sidebar.chatbot")}
                  </p>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={`/voice-assistant`}
                  className={({ isActive }) =>
                    `dashLinks w-full max-w-[254px] rounded-[31px] flex items-center gap-[10px] px-[20px] py-[10px]  ${
                      isActive ? "bg-darkblue text-white" : "text-[#143A62]"
                    }`
                  }
                >
                  <Icon icon="streamline:voice-mail" width={18} height={18} />
                  <p className="medium font-medium">
                    {t("dashboard.sidebar.voiceAssistant")}
                  </p>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="case/case-management"
                  onClick={onDropdownClick}
                  className={({ isActive }) =>
                    `dashLinks w-full max-w-[254px] h-fit rounded-[31px] justify-between flex flex-col items-center gap-[10px] pl-[20px] pr-[17px] py-[10px]  ${
                      isActive ? "bg-darkblue text-white" : "text-[#143A62]"
                    } ${
                      [
                        "case/case-management",
                        "/case/case-details",
                        "/contract/contract-management",
                        "/contract/contract-details",
                        "/evidence/evidence-management",
                        "/evidence/evidence-details",
                        "/client/client-information",
                        "/incident/incident-information",
                        "/client/client-details",
                        "/incident/incident-details",
                        "/legal/legal-proceedings-information",
                        "/legal/legal-proceedings-details",
                        "/measures/measures-information",
                        "/measures/measures-details",
                        "/confedentiality-and-security/details",
                        "/confedentiality-and-security/information",
                        "/legal-sectors/details",
                        "/legal-sectors/information",
                      ].includes(location.pathname)
                        ? "bg-darkblue text-white"
                        : "text-[#143A62]"
                    }`
                  }
                >
                  <div className="flex items-center justify-between w-full">
                    <div className="flex items-center gap-[10px]">
                      <Icon
                        icon="ion:calendar-outline"
                        width={20}
                        height={20}
                      />
                      <p className="medium font-medium">
                        {t("dashboard.sidebar.organize")}
                      </p>
                    </div>

                    <Icon
                      icon={
                        isdropdownopen
                          ? "mingcute:up-fill"
                          : "mingcute:down-fill"
                      }
                      width={20}
                      height={20}
                    />
                  </div>
                </NavLink>
                {isdropdownopen && (
                  <>
                    <div className="flex pl-[25px] items-center gap-[7px]">
                      <img
                        src="../../assets/images/dashboard/sidebarLine1.svg"
                        alt=""
                        className="mt-[-5px]"
                        style={{ height: "150px" }}
                      />
                      <div className="flex flex-col text-[#B5B5B5] gap-[18px] pt-[31px] font-medium small ">
                        <p
                          className="cursor-pointer"
                          onClick={onuploadwithAIClick}
                        >
                          {t("dashboard.sidebar.uploadWithAI")}
                        </p>
                        <p
                          onClick={() => {
                            navigate("/case/case-management");
                          }}
                          className={` cursor-pointer ${
                            location.pathname === "/case/case-details" ||
                            location.pathname === "/case/case-management"
                              ? "text-blue"
                              : ""
                          }`}
                        >
                          {t("dashboard.sidebar.caseManagement")}
                        </p>
                        {/* <p
                          onClick={() => {
                            navigate("/contract/contract-management");
                          }}
                          className={`cursor-pointer ${
                            location.pathname === "/contract/contract-management" ||
                            location.pathname === "/contract/contract-details"
                              ? "text-blue"
                              : ""
                          }`}
                        >
                          {t("dashboard.sidebar.contractManagement")}
                        </p> */}
                        {/* <p
                          onClick={() => {
                            navigate("/evidence/evidence-management");
                          }}
                          className={`cursor-pointer ${
                            location.pathname === "/evidence/evidence-management" ||
                            location.pathname === "/evidence/evidence-details"
                              ? "text-blue "
                              : ""
                          }`}
                        >
                          {t("dashboard.sidebar.evidenceManagement")}
                        </p> */}
                        <p
                          onClick={() => {
                            navigate("/client/client-information");
                          }}
                          className={`cursor-pointer ${
                            location.pathname ===
                              "/client/client-information" ||
                            location.pathname === "/client/client-details"
                              ? "text-blue "
                              : ""
                          }`}
                        >
                          {t("dashboard.sidebar.clientInformation")}
                        </p>
                        {/* <p
                          onClick={() => {
                            navigate("/incident/incident-information");
                          }}
                          className={`cursor-pointer ${
                            location.pathname === "/incident/incident-details" ||
                            location.pathname === "/incident/incident-information"
                              ? "text-blue "
                              : ""
                          }`}
                        >
                          {t("dashboard.sidebar.incidentInformation")}
                        </p> */}
                        {/* <p
                          onClick={() => {
                            navigate("/legal/legal-proceedings-information");
                          }}
                          className={`cursor-pointer ${
                            location.pathname === "/legal/legal-proceedings-information" ||
                            location.pathname === "/legal/legal-proceedings-details"
                              ? "text-blue "
                              : ""
                          }`}
                        >
                          {t("dashboard.sidebar.legalProceedings")}
                        </p> */}
                        {/* <p
                          onClick={() => {
                            navigate("/measures/measures-information");
                          }}
                          className={`cursor-pointer ${
                            location.pathname === "/measures/measures-information" ||
                            location.pathname === "/measures/measures-details"
                              ? "text-blue "
                              : ""
                          }`}
                        >
                          {t("dashboard.sidebar.protectiveMeasures")}
                        </p> */}
                        {/* <p className="cursor-pointer">Support Services</p> */}
                        <p
                          onClick={() => {
                            navigate(
                              "/confedentiality-and-security/information"
                            );
                          }}
                          className={`cursor-pointer ${
                            location.pathname ===
                              "/confedentiality-and-security/information" ||
                            location.pathname ===
                              "/confedentiality-and-security/details"
                              ? "text-blue "
                              : ""
                          }`}
                        >
                          {t("dashboard.sidebar.confidentialityAndSecurity")}
                        </p>
                        {/* <p 
                          onClick={() => {
                            navigate("/legal-sectors/information");
                          }}
                          className={`cursor-pointer ${
                            location.pathname === "/legal-sectors/information" ||
                            location.pathname === "/legal-sectors/details"
                              ? "text-blue "
                              : ""
                          }`}
                        >
                          {t("dashboard.sidebar.legalSectors")}
                        </p> */}
                      </div>
                    </div>
                  </>
                )}
              </li>
              <li></li>
              <li>
                <NavLink
                  to="/subscription"
                  className={({ isActive }) =>
                    `dashLinks w-full max-w-[254px] rounded-[31px] flex items-center gap-[10px] px-[20px] py-[10px]  ${
                      isActive ? "bg-darkblue text-white" : "text-[#143A62]"
                    }`
                  }
                >
                  <Icon icon="mdi:credit-card-outline" width={18} height={18} />
                  <p className="medium font-medium">
                    {t("dashboard.sidebar.subscription")}
                  </p>
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/settings"
                  className={({ isActive }) =>
                    `dashLinks w-full max-w-[254px] rounded-[31px] flex items-center gap-[10px] px-[20px] py-[10px]  ${
                      isActive ? "bg-darkblue text-white" : "text-[#143A62]"
                    }`
                  }
                >
                  <Icon icon="akar-icons:gear" width={18} height={18} />
                  <p className="medium font-medium">
                    {t("dashboard.sidebar.settings")}
                  </p>
                </NavLink>
              </li>
            </div>
            <div className="bottom-options ">
              <li
                className="flex text-[#143A62] items-center gap-[10px] px-[20px] py-[10px] cursor-pointer"
                onClick={onRateUSClick}
              >
                <Icon icon="mynaui:star" width={18} height={18} />
                <p className="medium font-medium">
                  {t("dashboard.sidebar.rateUs")}
                </p>
              </li>
              <li
                className="flex text-[#143A62] items-center gap-[10px] px-[20px] py-[10px] cursor-pointer"
                onClick={onlogoutClick}
              >
                <Icon icon="mi:log-out" width={18} height={18} />
                <p className="medium font-medium">
                  {t("dashboard.sidebar.logout")}
                </p>
              </li>
            </div>
          </ul>
        </div>
      </div>
      <div className="mobile-sidebar hidden max-md:flex relative">
        <Drawer
          placement="left"
          closable={false}
          onClose={toggleDrawer}
          open={isDrawerOpen}
          className="rounded-r-[20px] "
          width={340}
        >
          <div className="sidebar-container ">
            <img
              src={
                isDrawerOpen
                  ? "../../assets/icons/sidebarArrow-left.png"
                  : "../../assets/icons/sidebarArrow-right.png"
              }
              alt=""
              className="cursor-pointer absolute right-[-4%] z-[99999]"
              onClick={toggleDrawer}
            />
            <div className="sidebar-logo-container py-[30px]  flex items-center gap-[13px] justify-center">
              <Link to="/" target="_blank">
                <img
                  src="../../logo.png"
                  alt="logo"
                  className="logo w-[39px] h-[33px]"
                />
              </Link>
              <h6 className="text-blue font-medium">
                {t("dashboard.sidebar.logo")}
              </h6>
            </div>

            <div className="sidebar-options-container  min-h-fit h-full relative  rounded-b-[20px] rounded-t-[140px]">
              <ul className="flex flex-col gap-[15px] justify-between relative  w-full max-w-full">
                <div className="top-options flex flex-col gap-[15px]">
                  <li>
                    <NavLink
                      to="/dashboard"
                      onClick={toggleDrawer}
                      className={({ isActive }) =>
                        `dashLinks w-full  rounded-[31px] flex items-center gap-[10px] px-[20px] py-[10px]  ${
                          isActive ? "bg-darkblue text-white" : "text-[#143A62]"
                        }`
                      }
                    >
                      <Icon icon="ph:house-simple" width={20} height={20} />
                      <p className="large font-medium">
                        {t("dashboard.sidebar.home")}
                      </p>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/chatbot"
                      onClick={toggleDrawer}
                      className={({ isActive }) =>
                        `dashLinks w-full rounded-[31px] flex items-center gap-[10px] px-[20px] py-[10px]  ${
                          isActive ? "bg-darkblue text-white" : "text-[#143A62]"
                        }`
                      }
                    >
                      <Icon icon="carbon:chat-bot" width={20} height={20} />
                      <p className="large font-medium">
                        {t("dashboard.sidebar.chatbot")}
                      </p>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to={`/voice-assistant`}
                      onClick={toggleDrawer}
                      className={({ isActive }) =>
                        `dashLinks w-full max-w-[254px] rounded-[31px] flex items-center gap-[10px] px-[20px] py-[10px]  ${
                          isActive ? "bg-darkblue text-white" : "text-[#143A62]"
                        }`
                      }
                    >
                      <Icon
                        icon="streamline:voice-mail"
                        width={20}
                        height={20}
                      />
                      <p className="large font-medium">
                        {t("dashboard.sidebar.voiceAssistant")}
                      </p>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="case/case-management"
                      onClick={onDropdownClick}
                      className={({ isActive }) =>
                        `dashLinks w-full h-fit rounded-[31px] justify-between flex flex-col items-center gap-[10px] pl-[20px] pr-[17px] py-[10px]  ${
                          isActive ? "bg-darkblue text-white" : "text-[#143A62]"
                        } ${
                          [
                            "case/case-management",
                            "/case/case-details",
                            "/contract/contract-management",
                            "/contract/contract-details",
                            "/evidence/evidence-management",
                            "/evidence/evidence-details",
                            "/client/client-information",
                            "/incident/incident-information",
                            "/client/client-details",
                            "/incident/incident-details",
                            "/legal/legal-proceedings-information",
                            "/legal/legal-proceedings-details",
                            "/measures/measures-information",
                            "/measures/measures-details",
                            "/confedentiality-and-security/details",
                            "/confedentiality-and-security/information",
                            "/legal-sectors/details",
                            "/legal-sectors/information",
                          ].includes(location.pathname)
                            ? "bg-darkblue text-white"
                            : "text-[#143A62]"
                        }`
                      }
                    >
                      <div className="flex items-center justify-between w-full">
                        <div className="flex items-center gap-[10px]">
                          <Icon
                            icon="ion:calendar-outline"
                            width={20}
                            height={20}
                          />
                          <p className="large font-medium">
                            {t("dashboard.sidebar.organize")}
                          </p>
                        </div>

                        <Icon
                          icon={
                            isdropdownopen
                              ? "mingcute:up-fill"
                              : "mingcute:down-fill"
                          }
                          width={20}
                          height={20}
                        />
                      </div>
                    </NavLink>
                    {isdropdownopen && (
                      <>
                        <div className="flex pl-[25px] items-center gap-[7px]">
                          <img
                            src="../../assets/images/dashboard/sidebarLine1.svg"
                            alt=""
                            className="mt-[-5px]"
                            style={{ height: "150px" }}
                          />
                          <div className="flex flex-col text-[#B5B5B5] gap-[16px] pt-[39px] font-medium small ">
                            <p
                              className="cursor-pointer"
                              onClick={onuploadwithAIClick}
                            >
                              {t("dashboard.sidebar.uploadWithAI")}
                            </p>
                            <p
                              onClick={() => {
                                navigate("/case/case-management");
                                toggleDrawer();
                              }}
                              className={` cursor-pointer ${
                                location.pathname === "/case/case-details" ||
                                location.pathname === "/case/case-management"
                                  ? "text-blue"
                                  : ""
                              }`}
                            >
                              {t("dashboard.sidebar.caseManagement")}
                            </p>
                            {/* <p
                              onClick={() => {
                                navigate("/contract/contract-management");
                                toggleDrawer();
                              }}
                              className={`cursor-pointer ${
                                location.pathname ===
                                  "/contract/contract-management" ||
                                location.pathname ===
                                  "/contract/contract-details"
                                  ? "text-blue"
                                  : ""
                              }`}
                            >
                              {t("dashboard.sidebar.contractManagement")}
                            </p> */}
                            {/* <p
                              onClick={() => {
                                navigate("/evidence/evidence-management");
                                toggleDrawer();
                              }}
                              className={`cursor-pointer ${
                                location.pathname ===
                                  "/evidence/evidence-management" ||
                                location.pathname ===
                                  "/evidence/evidence-details"
                                  ? "text-blue "
                                  : ""
                              }`}
                            >
                              {t("dashboard.sidebar.evidenceManagement")}
                            </p> */}
                            <p
                              onClick={() => {
                                navigate("/client/client-information");
                                toggleDrawer();
                              }}
                              className={`cursor-pointer ${
                                location.pathname ===
                                  "/client/client-information" ||
                                location.pathname === "/client/client-details"
                                  ? "text-blue "
                                  : ""
                              }`}
                            >
                              {t("dashboard.sidebar.clientInformation")}
                            </p>
                            {/* <p
                              onClick={() => {
                                navigate("/incident/incident-information");
                                toggleDrawer();
                              }}
                              className={`cursor-pointer ${
                                location.pathname ===
                                  "/incident/incident-details" ||
                                location.pathname ===
                                  "/incident/incident-information"
                                  ? "text-blue "
                                  : ""
                              }`}
                            >
                              {t("dashboard.sidebar.incidentInformation")}
                            </p> */}
                            {/* <p
                              onClick={() => {
                                navigate(
                                  "/legal/legal-proceedings-information"
                                );
                                toggleDrawer();
                              }}
                              className={`cursor-pointer ${
                                location.pathname ===
                                  "/legal/legal-proceedings-information" ||
                                location.pathname ===
                                  "/legal/legal-proceedings-details"
                                  ? "text-blue "
                                  : ""
                              }`}
                            >
                              {t("dashboard.sidebar.legalProceedings")}
                            </p> */}
                            {/* <p
                              onClick={() => {
                                navigate("/measures/measures-information");
                                toggleDrawer();
                              }}
                              className={`cursor-pointer ${
                                location.pathname ===
                                  "/measures/measures-information" ||
                                location.pathname ===
                                  "/measures/measures-details"
                                  ? "text-blue "
                                  : ""
                              }`}
                            >
                              {t("dashboard.sidebar.protectiveMeasures")}
                            </p>
                            <p className="cursor-pointer">
                              {t("dashboard.sidebar.supportServices")}
                            </p> */}
                            <p
                              onClick={() => {
                                navigate(
                                  "/confedentiality-and-security/information"
                                );
                                toggleDrawer();
                              }}
                              className={`cursor-pointer ${
                                location.pathname ===
                                  "/confedentiality-and-security/information" ||
                                location.pathname ===
                                  "/confedentiality-and-security/details"
                                  ? "text-blue "
                                  : ""
                              }`}
                            >
                              {t(
                                "dashboard.sidebar.confidentialityAndSecurity"
                              )}
                            </p>
                            {/* <p
                              onClick={() => {
                                navigate("/legal-sectors/information");
                                toggleDrawer();
                              }}
                              className={`cursor-pointer ${
                                location.pathname ===
                                  "/legal-sectors/information" ||
                                location.pathname === "/legal-sectors/details"
                                  ? "text-blue "
                                  : ""
                              }`}
                            >
                              {t("dashboard.sidebar.legalSectors")}
                            </p> */}
                          </div>
                        </div>
                      </>
                    )}
                  </li>
                  <li>
                    <NavLink
                      to="/subscription"
                      onClick={toggleDrawer}
                      className={({ isActive }) =>
                        `dashLinks w-full rounded-[31px] flex items-center gap-[10px] px-[20px] py-[10px]  ${
                          isActive ? "bg-darkblue text-white" : "text-[#143A62]"
                        }`
                      }
                    >
                      <Icon
                        icon="mdi:credit-card-outline"
                        width={20}
                        height={20}
                      />
                      <p className="large font-medium">
                        {t("dashboard.sidebar.subscription")}
                      </p>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      to="/settings"
                      onClick={toggleDrawer}
                      className={({ isActive }) =>
                        `dashLinks w-full rounded-[31px] flex items-center gap-[10px] px-[20px] py-[10px]  ${
                          isActive ? "bg-darkblue text-white" : "text-[#143A62]"
                        }`
                      }
                    >
                      <Icon icon="akar-icons:gear" width={20} height={20} />
                      <p className="large font-medium">
                        {t("dashboard.sidebar.settings")}
                      </p>
                    </NavLink>
                  </li>
                  <li
                    className="flex text-[#143A62] items-center gap-[10px] px-[20px] py-[10px] cursor-pointer"
                    onClick={() => {
                      onRateUSClick();
                      toggleDrawer();
                    }}
                  >
                    <Icon icon="mynaui:star" width={20} height={20} />
                    <p className="large font-medium">
                      {t("dashboard.sidebar.rateUs")}
                    </p>
                  </li>
                </div>
                <div className="bottom-options ">
                  <li
                    className="flex text-[#143A62] items-center gap-[10px] px-[20px] py-[10px] cursor-pointer"
                    onClick={() => {
                      onlogoutClick();
                      toggleDrawer();
                    }}
                  >
                    <Icon icon="mi:log-out" width={20} height={20} />
                    <p className="large font-medium">
                      {t("dashboard.sidebar.logout")}
                    </p>
                  </li>
                </div>
              </ul>
            </div>
          </div>
        </Drawer>
      </div>
      <LogoutModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
      <UploadwithAI
        isuploadModelOpen={isuploadModelOpen}
        setisuploadModelOpen={setisuploadModelOpen}
      />
      <FeedbackModal
        isreminderModalOpen={isreminderModalOpen}
        setisreminderModalOpen={setisreminderModalOpen}
      />
    </>
  );
};

export default Sidebar;
